import { Field, FormRenderProps } from "@progress/kendo-react-form"
import styles from '../../../styles/estrategiaAdaptacao/EstrategiaAdaptacao.module.scss';
import { Checkbox, Input } from "@progress/kendo-react-inputs";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { entidades, get, getEaRegistoAnalise } from "../../../services/utils";
import { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import { filterBy } from "@progress/kendo-data-query";
import { DateTimePicker } from "@progress/kendo-react-dateinputs";
import FieldsetCombosLocalizacao from "../../localizacao/FieldsetCombosLocalizacao";
import ValidatedIdentificacaoCheckbox from "./ValidationComponentes/ValidatedIdentificacaoCheckbox";
import { requiredFieldValidator } from "../../../validations/ocorrencia";
import useVisibleColumns, { Key } from "../../../hooks/useVIsibleColumns";
import SessionStorageService from "../../../services/SessionStorageService";
import { Grid, GridCellProps, GridColumn, GridPageChangeEvent, GridToolbar } from "@progress/kendo-react-grid";
import { PagerTargetEvent } from '@progress/kendo-react-data-tools'
import { ResultadoValorUsoDoSoloCommandGridCell } from "../../usosdosolo/ResultadoValorUsoDoSoloCommandGridCell";
import { useValorUsoDoSoloStore } from "../../../stores/valorUsoDoSolo";
import DetalheValorUsoDoSolo from "../../usosdosolo/DetalheValorUsoDoSolo";
import { Dialog } from '@progress/kendo-react-dialogs'
import VisualizadorColunas from "../../Generico/VisualizadorColunas ";
import { ResultadoAcaoCommandGridCell } from "../../intervencao/ResultadoAcaoCommandGridCell";
import { process } from '@progress/kendo-data-query';
import { fs1Ano, fs2Ano, PESQUISAR_ACAO } from "../../../utils/constants";
import { Line } from "react-chartjs-2";
import { Scatter } from 'react-chartjs-2';
import html2canvas from "html2canvas";
import ReactGA from 'react-ga4';
import moment from 'moment';

type IProps = {
    idForm?: number
    initialValuesForm?: any
    viewMode?: boolean
    isMobile?: boolean
}

type ValorTituloUsoDoSolo = {
    id: number;
    vus: string;
    tipo: string;
    valor: string;
}

type PageState = {
    skip: number
    take: number
}

type InfoGraph = {
    label: string
    borderColor: string
    backgroundColor: string
    data: any[],
    showLine: boolean
}

const keyPainelPrincipal: Key = 'acaoColunasVisiveis';

const AnaliseEstrategiaAdaptacao = forwardRef(({
    idForm, initialValuesForm, viewMode, isMobile
}: IProps, ref: React.Ref<any>) => {

    const [showNivel1, setShowNivel1] = useState<boolean>(false)
    const [showNivel2, setShowNivel2] = useState<boolean>(false)

    const [dataRelatorio, setDataRelatorio] = useState<Date>(new Date())
    const [labelsAcoes, setLabelsAcoes] = useState<number[]>([])
    const [labelsYAcoes, setLabelsYAcoes] = useState<number[]>([])

    const [labels, setLabels] = useState<number[]>([dataRelatorio.getFullYear(), fs1Ano])

    const [dataAcoes, setDataAcoes] = useState({
        labels: labelsAcoes,
        datasets: [{
            label: "Investimento Realizado",
            data: labelsYAcoes,
            borderColor: "blue",
            backgroundColor: "white",
            showLine: true
        }]
    });

    const _graficos: InfoGraph[] = [];

    const [analiseDados, setAnaliseDados] = useState({
        isRetirada: false,
        isAdaptacao: false,
        isDefesa: false,
        isDefesaAdaptacao: false,
        graficos: _graficos,
        vusFS1: 0,
        vusFS2: 0,
        custoRetirada50: 0,
        custoRetirada100: 0,
        custoAdaptacao50: 0,
        custoAdaptacao100: 0,
        custoDefesa50: 0,
        custoDefesa100: 0,
        custoDefesaAnoActual: 0,
        custoDefesaAdaptacao50: 0,
        custoDefesaAdaptacao100: 0
    });

    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: "/AnaliseEstrategiaAdaptacao" });
    }, []);

    useEffect(() => {
        loadInterface();
       
    }, [])

    useEffect(() => {
        loadInterface();
    }, [initialValuesForm])

    useEffect(() => {
        setLabels([dataRelatorio.getFullYear(), fs1Ano, fs2Ano]);
    }, [dataRelatorio])


    const scaleMillionValue = (numero: number): number => {
        return numero / 1000000;
    };

    const loadInterface = () => {

        try {

            const visibleNivel1 = 1 in initialValuesForm.cod_salvaguarda_faixa;
            const visibleNivel2 = 2 in initialValuesForm.cod_salvaguarda_faixa;
            
            setShowNivel1(visibleNivel1);
            setShowNivel2(visibleNivel2);

            const maxX = visibleNivel2 ? fs2Ano : fs1Ano;

            // process acoes data
            const ysAcumulado = initialValuesForm?.xyAcumulados?.filter((point: { x: number }) => {
                return !visibleNivel1 && point.x == fs1Ano ? false : point.x <= maxX;
            }).map((point: { x: number }) => {
                return initialValuesForm.tendencia.slope * point.x + initialValuesForm.tendencia.intercept;
            });

            const investimento_realizado_acumulado = initialValuesForm?.xyAcumulados?.filter((point: { x: number }) => {
                return point.x <= maxX;
            }).map((point: { x: number, y: number }) => (point.y));


            setDataAcoes({
                labels: initialValuesForm?.xyAcumulados?.map((point: any) => point.x),
                datasets: [
                    /*{
                        label: "Linear (Investimento Realizado [M€])",
                        data: ys,
                        borderColor: "lightblue",
                        backgroundColor: "white"
                    },
                    {
                        label: "Investimento Realizado [M€]",
                        data: investimento_realizado,
                        borderColor: "blue",
                        backgroundColor: "white"
                    },*/
                    {
                        label: "Investimento Realizado Acumulado [M€]",
                        data: investimento_realizado_acumulado,
                        borderColor: "green",
                        backgroundColor: "white",
                        showLine: true
                    },
                    {
                        label: "Linha de Tendência [M€]",
                        data: ysAcumulado,
                        borderColor: "lightgreen",
                        backgroundColor: "white",
                        showLine: true
                    }
                ]
            });

            // process analise data
            const eaRegistoAnalise = initialValuesForm;

            let graficos: InfoGraph[] = [];

            if (!eaRegistoAnalise?.vus) return;

            const valorTotalFaixa1 = eaRegistoAnalise?.vus?.reduce((acc: any, vus: { valor: any; nivel_faixa: number }) => vus.nivel_faixa === 1 ? acc + vus.valor : acc + 0, 0);
            const valorTotalFaixa2 = eaRegistoAnalise?.vus?.reduce((acc: any, vus: { valor: any; nivel_faixa: number }) => vus.nivel_faixa === 2 ? acc + vus.valor : acc + 0, 0);

            const edificiosFaixa1 = eaRegistoAnalise?.vus?.filter((e: any) => e.usTipoComponenteVus.is_edificio && e.nivel_faixa === 1)
            const edificiosFaixa2 = eaRegistoAnalise?.vus?.filter((e: any) => e.usTipoComponenteVus.is_edificio && e.nivel_faixa === 2)

            const sumVus1 = edificiosFaixa1.reduce((acc: any, vus: { valor: any; }) => acc + vus.valor, 0)
            const sumVus2 = edificiosFaixa2.reduce((acc: any, vus: { valor: any; }) => acc + vus.valor, 0)

            const sumAreaVus1 = edificiosFaixa1.reduce((acc: any, vus: { valor: any; area_implantacao: any }) => acc + vus.area_implantacao, 0)
            const sumAreaVus2 = edificiosFaixa2.reduce((acc: any, vus: { valor: any; area_implantacao: any }) => acc + vus.area_implantacao, 0)

            const vusFS1 = eaRegistoAnalise?.valorTotalFS50Anos;
            const vusFS2 = eaRegistoAnalise?.valorTotalFS100Anos;

            const custo_adaptacao_edificio = eaRegistoAnalise["custo_adaptacao_edificio"] ? eaRegistoAnalise["custo_adaptacao_edificio"] : 0;
            const custo_demolicao_edificio = eaRegistoAnalise["custo_demolicao"] ? eaRegistoAnalise["custo_demolicao"] : 0;
            const custo_renaturalizacao_edificio = eaRegistoAnalise["custo_renaturalizacao"] ? eaRegistoAnalise["custo_renaturalizacao"] : 0;

            // custo_adaptacao_edificio * area_edificios
            const custoAdaptacao50 = custo_adaptacao_edificio ? custo_adaptacao_edificio * sumAreaVus1 : 0;
            const custoAdaptacao100 = custo_adaptacao_edificio ? custo_adaptacao_edificio * sumAreaVus2 : 0;

            // valor_todas_areas + (area_edificios * custo_demolicao_edificio) + (area_edificios * custo_renaturalizacao_edificio)
            const custoRetirada50 = valorTotalFaixa1 + (sumAreaVus1 * custo_demolicao_edificio) + (sumAreaVus1 * custo_renaturalizacao_edificio);
            const custoRetirada100 = valorTotalFaixa2 + (sumAreaVus2 * custo_demolicao_edificio) + (sumAreaVus2 * custo_renaturalizacao_edificio);

            setDataRelatorio(eaRegistoAnalise?.dataRelatorio ? (eaRegistoAnalise?.dataRelatorio instanceof Date ? eaRegistoAnalise?.dataRelatorio : new Date(eaRegistoAnalise?.dataRelatorio)) : new Date());
            SessionStorageService.setItem("dataRelatorio", 
                eaRegistoAnalise?.dataRelatorio ? (eaRegistoAnalise?.dataRelatorio instanceof Date ? eaRegistoAnalise?.dataRelatorio : new Date(eaRegistoAnalise?.dataRelatorio)) : new Date()
            );
           
            // defesa
            let custoDefesaAnoActual = 0;
            let custoDefesa50 = 0;
            let custoDefesa100 = 0;

            if (eaRegistoAnalise?.acoesAtivas?.length > 0) {
                custoDefesaAnoActual = eaRegistoAnalise?.tendenciaRaw?.slope * (eaRegistoAnalise?.dataRelatorio ? eaRegistoAnalise?.dataRelatorio.getFullYear() : new Date().getFullYear()) + eaRegistoAnalise?.tendenciaRaw?.intercept;
                custoDefesa50 = eaRegistoAnalise?.tendenciaRaw?.slope * fs1Ano + eaRegistoAnalise?.tendenciaRaw?.intercept;
                custoDefesa100 = eaRegistoAnalise?.tendenciaRaw?.slope * fs2Ano + eaRegistoAnalise?.tendenciaRaw?.intercept;
            }

            const newLabels = [dataRelatorio.getFullYear()];

            if (visibleNivel1) {
                newLabels.push(fs1Ano);
            }
            if (visibleNivel2) {
                newLabels.push(fs2Ano);
            }
            setLabels(newLabels);

            // defesa + adaptacao
            const custoDefesaAdaptacaoAnoActual = custoDefesaAnoActual;
            const custoDefesaAdaptacao50 = custoDefesa50 + custoAdaptacao50;
            const custoDefesaAdaptacao100 = custoDefesa100 + custoAdaptacao100;

            const isRetirada = eaRegistoAnalise?.retirada ?? false;
            const isAdaptacao = eaRegistoAnalise?.adaptacao ?? false;
            const isDefesa = eaRegistoAnalise?.defesa ?? false;
            const isDefesaAdaptacao = eaRegistoAnalise?.defesa_adaptacao ?? false;

            if (isRetirada) {

                if (visibleNivel1) {
                    graficos = [...graficos, {
                        label: "Retirada FS1",
                        data: Array(newLabels.length).fill(scaleMillionValue(custoRetirada50)),
                        borderColor: "red",
                        backgroundColor: "white",
                        showLine: true
                    }]
                }

                if (visibleNivel2) {
                    graficos = [...graficos, {
                        label: "Retirada FS2",
                        data: Array(newLabels.length).fill(scaleMillionValue(custoRetirada100)),
                        borderColor: "orange",
                        backgroundColor: "white",
                        showLine: true
                    }]
                }
            }
            if (isDefesa) {

                const dataGraficDef = [scaleMillionValue(custoDefesaAnoActual)];

                if (visibleNivel1) {
                    dataGraficDef.push(scaleMillionValue(custoDefesa50));
                }
                if (visibleNivel2) {
                    dataGraficDef.push(scaleMillionValue(custoDefesa100));
                }

                graficos = [...graficos,
                {
                    label: "Defesa [M€]",
                    data: dataGraficDef,
                    borderColor: "green",
                    backgroundColor: "white",
                    showLine: true
                }]
            }
            if (isDefesaAdaptacao) {

                const dataGraficDefAdapt = [scaleMillionValue(custoDefesaAdaptacaoAnoActual)];

                if (visibleNivel1) {
                    dataGraficDefAdapt.push(scaleMillionValue(custoDefesaAdaptacao50));
                }
                if (visibleNivel2) {
                    dataGraficDefAdapt.push(scaleMillionValue(custoDefesaAdaptacao100));
                }

                graficos = [...graficos,
                {
                    label: "Defesa + Adaptação [M€]",
                    data: dataGraficDefAdapt,
                    // data: [scaleMillionValue(custoDefesaAdaptacaoAnoActual), scaleMillionValue(custoDefesaAdaptacao50), scaleMillionValue(custoDefesaAdaptacao100)],
                    borderColor: "blue",
                    backgroundColor: "white",
                    showLine: true
                }]
            }
            if (isAdaptacao) {

                const dataGraficAdapt = [0];

                if (visibleNivel1) {
                    dataGraficAdapt.push(scaleMillionValue(custoAdaptacao50));
                }
                if (visibleNivel2) {
                    dataGraficAdapt.push(scaleMillionValue(custoAdaptacao100));
                }

                graficos = [...graficos,
                {
                    label: "Adaptação [M€]",
                    data: dataGraficAdapt,
                    // data: [0, scaleMillionValue(custoAdaptacao50), scaleMillionValue(custoAdaptacao100)],
                    borderColor: "gray",
                    backgroundColor: "white",
                    showLine: true
                }]
            }


            setAnaliseDados({
                isRetirada,
                isAdaptacao,
                isDefesa,
                isDefesaAdaptacao,
                graficos,
                vusFS1,
                vusFS2,
                custoRetirada50,
                custoRetirada100,
                custoDefesaAnoActual,
                custoAdaptacao50,
                custoAdaptacao100,
                custoDefesa50,
                custoDefesa100,
                custoDefesaAdaptacao50,
                custoDefesaAdaptacao100
            });
            SessionStorageService.setItem("dataAnaliseDados", {
                isRetirada,
                isAdaptacao,
                isDefesa,
                isDefesaAdaptacao,
                graficos,
                vusFS1,
                vusFS2,
                custoRetirada50,
                custoRetirada100,
                custoDefesaAnoActual,
                custoAdaptacao50,
                custoAdaptacao100,
                custoDefesa50,
                custoDefesa100,
                custoDefesaAdaptacao50,
                custoDefesaAdaptacao100
            });

            saveScreenById("analise", {
                vusFS1,
                vusFS2,
                custoRetirada50,
                custoRetirada100,
                ano: dataRelatorio.getFullYear(),
                custoAdaptacao50,
                custoAdaptacao100,
                custoDefesa50,
                custoDefesa100,
                custoDefesaAdaptacao50,
                custoDefesaAdaptacao100,
            })

        } catch (e) {
            postMessage({ type: 'errorMsg', value: { message: "Não foi possivel efetuar esta operação" } }, '*')
        }
        finally {
            postMessage({ type: 'hideLoader' }, '*')
        }
    }

    const optionsAcoes = {
        plugins: {
            legend: {
                display: true,
                position: 'top' as const // Aseguramos que el tipo sea uno de los permitidos
            },
            title: {
                display: true,
                text: "Investimento em obras de defesa"
            }
        },
        scales: {
            x: {
                type: 'linear' as const,
                position: 'bottom' as const,
                title: {
                    display: true,
                    text: 'Tempo'
                }
            },
            y: {
                title: {
                    display: true,
                    text: 'Investimento'
                }
            }
        }
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: "top" as const
            },
            title: {
                display: true,
                text: "Comparação entre custos de retirada, defesa e adaptação"
            }
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: 'tempo',
                    color: 'black'
                }
            },
            y: {
                title: {
                    display: true,
                    text: 'Investimento [M€]',
                    color: 'black'
                }
            }
        }
    };

    const data = {
        labels,
        datasets: analiseDados.graficos
    };

    const getFormatedEurNumber = (v: number) => {
        return new Intl.NumberFormat('pt-PT', { style: 'currency', currency: 'EUR' }).format(v);
    }

    const styleMoneyText: any = { textAlign: 'right' };

    const dataCabecalho = () => {

        const style = isMobile ? { flex: '1 1 50%', padding: '15px 5px 5px 5px' } : { flex: 1, padding: '15px 5px 5px 5px' };
        const styleTitle = { marginBottom: '10px', fontWeight: 'bold' };

        return (
            <div style={{ display: "flex", flexDirection: "row", flexWrap: 'wrap' }}>
                {analiseDados.isRetirada && (
                    <div style={style}>
                        <div style={styleTitle}>
                            <h1>Retirada</h1>
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                            {showNivel1 && (<div style={{ display: "flex", flexDirection: "row", gap: 20 }}>
                                <h2>FS1:</h2> <span style={styleMoneyText}>{getFormatedEurNumber(analiseDados.custoRetirada50)}</span>
                            </div>)}
                            { showNivel2 && (<div style={{ display: "flex", flexDirection: "row", gap: 20 }}>
                                <h2>FS2:</h2><span style={styleMoneyText}>{getFormatedEurNumber(analiseDados.custoRetirada100)}</span>
                            </div>)}
                        </div>
                    </div>
                )}

                {analiseDados.isAdaptacao && (
                    <div style={style}>
                        <div style={styleTitle}>
                            <h1>Adaptação</h1>
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                            <div style={{ display: "flex", flexDirection: "row", gap: 20 }}>
                                <h2>{dataRelatorio.getFullYear()}:</h2> <span>{getFormatedEurNumber(0)}</span>
                            </div>
                            {showNivel1 && (<div style={{ display: "flex", flexDirection: "row", gap: 20 }}>
                                <h2>{fs1Ano}:</h2> <span>{getFormatedEurNumber(analiseDados.custoAdaptacao50)}</span>
                            </div>)}
                            {showNivel2 && (<div style={{ display: "flex", flexDirection: "row", gap: 20 }}>
                                <h2>{fs2Ano}:</h2> <span>{getFormatedEurNumber(analiseDados.custoAdaptacao100)}</span>
                            </div>)}
                        </div>
                    </div>
                )}

                {analiseDados.isDefesa && (
                    <div style={style}>
                        <div style={styleTitle}>
                            <h1>Defesa</h1>
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                            <div style={{ display: "flex", flexDirection: "row", gap: 20 }}>
                                <h2>{dataRelatorio.getFullYear()}:</h2> <span>{getFormatedEurNumber(analiseDados.custoDefesaAnoActual)}</span>
                            </div>
                            {showNivel1 && (<div style={{ display: "flex", flexDirection: "row", gap: 20 }}>
                                <h2>{fs1Ano}:</h2> <span>{getFormatedEurNumber(analiseDados.custoDefesa50)}</span>
                            </div>)}
                            {showNivel2 && (<div style={{ display: "flex", flexDirection: "row", gap: 20 }}>
                                <h2>{fs2Ano}:</h2> <span>{getFormatedEurNumber(analiseDados.custoDefesa100)}</span>
                            </div>)}
                        </div>
                    </div>
                )}

                {analiseDados.isDefesaAdaptacao && (
                    <div style={style}>
                        <div style={styleTitle}>
                            <h1>Defesa + Adaptação</h1>
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                            <div style={{ display: "flex", flexDirection: "row", gap: 20 }}>
                                <h2>{dataRelatorio.getFullYear()}:</h2> <span>{getFormatedEurNumber(analiseDados.custoDefesaAnoActual)}</span>
                            </div>
                            {showNivel1 && (<div style={{ display: "flex", flexDirection: "row", gap: 20 }}>
                                <h2>{fs1Ano}:</h2> <span>{getFormatedEurNumber(analiseDados.custoDefesaAdaptacao50)}</span>
                            </div>)}
                            {showNivel2 && (<div style={{ display: "flex", flexDirection: "row", gap: 20 }}>
                                <h2>{fs2Ano}:</h2> <span>{getFormatedEurNumber(analiseDados.custoDefesaAdaptacao100)}</span>
                            </div>)}
                        </div>
                    </div>
                )}
            </div>
        );
    };

    const saveScreenById = async (key: string, props: any) => {

        const divGraficoArea = document.querySelector(
            '#graficoAnalise'
        ) as HTMLCanvasElement

        const generatedImageGrafico = await html2canvas(divGraficoArea)
        const grafico = generatedImageGrafico.toDataURL()
        SessionStorageService.setItem(key, JSON.stringify({
            img_grafico_analise: grafico,
            ...props
        }))
    }

    return (
        <div className={`${styles.form} ${styles.removeScrollDuplicado}`} style={{ paddingTop: '5px', paddingBottom: '5px', overflowX: 'inherit' }}>
            <Scatter options={optionsAcoes} data={dataAcoes} id="graficoAcao" />
            <Scatter style={{ marginTop: '40px' }} options={options} data={data} id="graficoAnalise" />
            <fieldset>
                <div className={styles.espacoVerticalFieldSet}>
                    {dataCabecalho()}
                </div>
            </fieldset>
        </div>
    );
});

export default AnaliseEstrategiaAdaptacao;